<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-img [src]="'/assets/logos/tris-multiplicador.svg'"></ion-img>
  </ion-toolbar>
</ion-header>
<ion-grid fixed>
  <ion-row>
    <ion-col class="quantity" size="12">
      <app-quantity
        [min]="min"
        [max]="max"
        [quantity]="quantity"
        [isInput]="true"
        (quantityChange)="(quantity = $event) && calculatePrizes()"
        [showMaxMessage]="true"
        [message]="
          'Recuerda que la apuesta de Tris Multiplicador debe ser menor o igual la de Tris, y en su conjunto no deberán de exceder $' +
          (ticket.price.code === 'pack10' ? '50 en Combo 10.' : '100.')
        "
      ></app-quantity>
    </ion-col>
    <ion-col size="12">
      <ion-card>
        <ion-list>
          <ion-item lines="full">
            <ion-label slot="start">Premio Tris</ion-label>
            <ion-label slot="end">{{ prize | currency }}</ion-label>
          </ion-item>
          <ion-item lines="full">
            <ion-label slot="start">P. Multiplicador</ion-label>
            <ion-label slot="end">{{ prizeMultiplicador | currency }}</ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-label slot="start"><strong>Total</strong></ion-label>
            <ion-label slot="end"
              ><strong>{{ prize + prizeMultiplicador | currency }}</strong></ion-label
            >
          </ion-item>
        </ion-list>
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="8" offset="2">
      <ion-button (click)="send()" expand="block" shape="round"> Aceptar </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
